import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import $ from 'jquery';

import css from 'css';
import WP from 'WP';
import { H2, H3, h3Styles } from 'partials/typography';
import { Select, Button } from 'partials/formElements';
import { popConfetti, gtmPush } from 'helpers';
import Container from 'partials/Container';
import { calculatePoints } from 'partials/modules/Calculator';

import {
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setCourseOfStudyValue,
    setBookingMeetingType,
} from 'store';

class Summary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            courseOfStudy: this.props.courseOfStudy,
        }
    }

    componentDidMount() {

        $('html, body').animate({
            scrollTop: $("#calculator-summary").offset().top
        }, 200);

        setTimeout(() => (popConfetti({
            color: '#006CEF',
            selector: '#calculator-summary'
        })), 400);

        gtmPush({
            'event': 'karakterCalculator',
            'eventCategory':  'karakter calculator',
            'eventAction':  this.props.calculator.selectedSet
        })
    }

    _selectOptions() {
        if(!WP.options.courses_of_study) return [];
        return Object.keys(WP.options.courses_of_study).map(courseOfStudy => ({ value: courseOfStudy , name: courseOfStudy }));
    }

    _onSelectCareer(e) {
        this.setState({ courseOfStudy: e.target.value });
        this.props.setCourseOfStudyValue(e.target.value);
    }

    _onContactButtonClick() {
        const { setBookingVisibility, setBookingProgressCollapsedValue, setCartCollapsedValue, setBookingMeetingType } = this.props;

        setBookingVisibility(true);
        setBookingProgressCollapsedValue(false);
        setCartCollapsedValue(true);
        setBookingMeetingType('Lånekassen');
    }

    _renderTableRows() {
        const set = WP.options.courses_of_study[this.state.courseOfStudy];
        const { programs, yearBorn, additionalPoints } = this.props.calculator;
        const summary = calculatePoints({ programs, yearBorn, additionalPoints });

        const schoolsWithMinPoints = set.filter(school => school['Poenggrense i ordinær kvote'] && school['Poenggrense i ordinær kvote'] !== 'Alle');
        const choolsWIthoutMinPoints = set.filter(school => school['Poenggrense i ordinær kvote'] && school['Poenggrense i ordinær kvote'] === 'Alle');

        if(set) {
            return [...schoolsWithMinPoints, ...choolsWIthoutMinPoints].map((school, i) => {
                let missingPoints = Number(school['Poenggrense i ordinær kvote']) - Number(summary.total);
                return(
                    <tr key={i}>
                        <td>
                            {school.Lærested}
                            <div>{school['Studium']}</div>
                        </td>
                        <td>{school['Poenggrense i ordinær kvote']}</td>
                        <td>{missingPoints > 0 ? missingPoints.toFixed(1) : 0}</td>
                        <td>{school['Spesielle opptakskrav']}</td>
                    </tr>
                );
            });
        }
    }

    render() {
        const { courseOfStudy } = this.state;
		const { year } = WP.options;

        return (
            <Wrapper id="calculator-summary">

                <H2>Bra jobba!</H2>
                <H3>Hva ønsker du å studere?</H3>

                <Select
                    value={courseOfStudy}
                    label="Studieretninger"
                    options={this._selectOptions()}
                    onChange={this._onSelectCareer.bind(this)}
                    white
                    className="select"
                />

                {courseOfStudy && WP.options.courses_of_study[courseOfStudy] &&
                    <Container small>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Studiested</th>
                                    <th>Krav for {year}</th>
                                    <th>Poeng som mangler</th>
                                    <th>Spesielle <br/>opptakskrav</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this._renderTableRows()}
                            </tbody>
                        </Table>
                    </Container>
                }

                {courseOfStudy &&
                    <Footer>
                        <p>Vil du finne ut hvordan du kan oppnå de<br/> resterende poengene?</p>
                        <Button red outline onClick={this._onContactButtonClick.bind(this)} >Snakk med en av våre rådgivere!</Button>
                    </Footer>
                }

            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    calculator: state.calculator,
    courseOfStudy: state.calculator.courseOfStudy,
});

const actions = {
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setCourseOfStudyValue,
    setBookingMeetingType
}

export default connect(mapStateToProps, actions)(Summary);

const Wrapper = styled.div`
    background: ${css.colors.main};
    color: #fff;
    position:relative;
    padding: 70px 0;
    display: flex;
    align-items:center;
    flex-direction: column;
    min-height: 600px;

    .select {
        margin-bottom: 20px;
        > div {
            background: #fff;
            width: 260px;
            color: ${css.colors.main};
            svg rect {
                fill: ${css.colors.blue};
            }
        }
    }

    canvas {
        position:absolute!important;
        top:0;
        left:0;
        width:100%;
        height:100%;
    }

    h2 {
        margin-bottom: 15px;
    }

    h3 {
        margin-bottom:20px;
    }
`

const Table = styled.table`
    margin: 60px 20px 60px 20px;
    width:100%;
    @media(max-width: 1000px) {
        margin: 50px 0;
    }
    thead {
        tr {
            th {
                text-align: left;
                font-size:16px;
                padding-bottom:10px;
                &:first-child {
                    max-width: 350px;
                }
            }
        }
    }
    tbody {
        tr {
            td {
                ${h3Styles}
                padding: 12px 20px 12px 0;
                border-bottom: 1px solid ${css.colors.blue};
                div {
                    padding-top:2px;
                    font-size: 16px;
                }
                @media(max-width: 767px) {
                    font-size:16px;
                }
                &:first-child {
                    max-width: 350px;
                }
            }
        }
    }
`

const Footer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom:10px;
    p {
        ${h3Styles}
        margin-bottom: 30px;
        text-align: center;
    }
    button {
        color:#fff;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/Summary.js